module.exports = __webpack_public_path__ + "static/media/qeios_logo.c681131c.png";